module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Find product...":"Artikel finden...","Configure product":"Artikel konfigurieren"}}')
  delete Component.options._Ctor
}
